import React, { useState, useEffect } from "react";
import { LayoutMain } from "../LayoutMain";
import moment from "moment/moment";

// Generar intervalos de horas (8:00 AM - 18:00 PM)
const hoursList = Array.from({ length: 11 }, (_, i) => {
  const hour = i + 8;
  return `${hour.toString().padStart(2, "0")}:00`;
});

export const Agenda = () => {
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0],
  );

  // Estado para almacenar citas: { id, date, time, title, description }
  const [appointments, setAppointments] = useState([
    {
      id: "1",
      date: new Date().toISOString().split("T")[0],
      time: "09:00",
      title: "Reunión de equipo",
      description: "Revisión de avance del proyecto",
    },
  ]);

  // Estado para el formulario de nueva cita
  const [newApp, setNewApp] = useState({
    time: "08:00",
    title: "",
    description: "",
  });

  // Filtrar citas según la fecha seleccionada
  const currentAppointments = appointments.filter(
    (app) => app.date === selectedDate,
  );

  const handleAddAppointment = (e) => {
    e.preventDefault();
    if (!newApp.title.trim()) return;

    const appointment = {
      id: Date.now().toString(),
      date: selectedDate,
      time: newApp.time,
      title: newApp.title,
      description: newApp.description,
    };

    setAppointments([...appointments, appointment]);
    setNewApp({ time: "08:00", title: "", description: "" });
  };

  const handleDelete = (id) => {
    setAppointments(appointments.filter((app) => app.id !== id));
  };

  return (
    <div style={{ border: 'solid 1px #d1d5db', borderRadius: '2%', borderColor: "#6b7280", padding: '20px' }}>
      <header style={styles.header}>
        <div style={styles.dateSelector}>
          <label htmlFor="agenda-date">Fecha: </label>
          <input
            id="agenda-date"
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            style={styles.input}
          />
        </div>
      </header>

      <div>
        {/* Formulario para agregar citas */}
        {/* <section style={styles.formSection}>
            <h5>Agendar para {moment(selectedDate).format('DD/MMM/YYYY')}</h5>
            <br></br>
            <form onSubmit={handleAddAppointment} style={styles.form}>
              <div style={styles.formGroup}>
                <label>Hora:</label>
                <select
                  value={newApp.time}
                  onChange={(e) =>
                    setNewApp({ ...newApp, time: e.target.value })
                  }
                  style={styles.input}
                >
                  {hoursList.map((hour) => (
                    <option key={hour} value={hour}>
                      {hour}
                    </option>
                  ))}
                </select>
              </div>

              <div style={styles.formGroup}>
                <label>Título / Tarea:</label>
                <input
                  type="text"
                  placeholder="Ej. Consulta o Reunión"
                  value={newApp.title}
                  onChange={(e) =>
                    setNewApp({ ...newApp, title: e.target.value })
                  }
                  style={styles.input}
                  required
                />
              </div>

              <div style={styles.formGroup}>
                <label>Descripción (Opcional):</label>
                <textarea
                  placeholder="Detalles adicionales..."
                  value={newApp.description}
                  onChange={(e) =>
                    setNewApp({ ...newApp, description: e.target.value })
                  }
                  style={{
                    ...styles.input,
                    height: "60px",
                    resize: "vertical",
                  }}
                />
              </div>

              <button type="submit" style={styles.button}>
                Guardar Cita
              </button>
            </form>
          </section> */}

        {/* Timeline / Agenda por horas */}
        <section style={styles.timelineSection}>
          {/* <h3>Horario ({moment(selectedDate).format('DD/MMM/YYYY')})</h3> */}
          <div style={styles.timeline}>
            {hoursList.map((hour) => {
              const appInHour = currentAppointments.filter(
                (app) => app.time === hour,
              );

              return (
                <div key={hour} style={styles.hourSlot}>
                  <div style={styles.timeLabel}>{hour}</div>
                  <div style={styles.eventsArea}>
                    {appInHour.length > 0 ? (
                      appInHour.map((app) => (
                        <div key={app.id} style={styles.eventCard}>
                          <div style={styles.eventInfo}>
                            <strong>{app.title}</strong>
                            {app.description && (
                              <p style={styles.eventDesc}>{app.description}</p>
                            )}
                          </div>
                          <button
                            onClick={() => handleDelete(app.id)}
                            style={styles.deleteButton}
                            title="Eliminar cita"
                          >
                            ×
                          </button>
                        </div>
                      ))
                    ) : (
                      <span style={styles.emptySlot}>Disponible</span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </div>
    </div>
  );
};

// Estilos básicos en JS para una integración rápida
const styles = {
  container: {
    fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
    margin: "20px auto",
    padding: "20px",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "2px solid #f0f0f0",
    paddingBottom: "15px",
    marginBottom: "20px",
  },
  dateSelector: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontWeight: "bold",
  },
  content: {
    display: "grid",
    gridTemplateColumns: "1fr 1.5fr",
    gap: "24px",
  },
  formSection: {
    backgroundColor: "#f9fafb",
    padding: "16px",
    borderRadius: "8px",
    border: "1px solid #e5e7eb",
    height: "fit-content",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  input: {
    padding: "8px 12px",
    borderRadius: "6px",
    border: "1px solid #d1d5db",
    fontSize: "14px",
  },
  button: {
    backgroundColor: "#2563eb",
    color: "#fff",
    padding: "10px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    marginTop: "8px",
  },
  timelineSection: {
    display: "flex",
    flexDirection: "column",
  },
  timeline: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  hourSlot: {
    display: "flex",
    alignItems: "flex-start",
    borderBottom: "1px solid #f3f4f6",
    paddingBottom: "8px",
    minHeight: "48px",
  },
  timeLabel: {
    width: "60px",
    fontWeight: "600",
    color: "#6b7280",
    fontSize: "13px",
    paddingTop: "4px",
  },
  eventsArea: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  eventCard: {
    backgroundColor: "#eff6ff",
    borderLeft: "4px solid #2563eb",
    padding: "8px 12px",
    borderRadius: "4px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  eventInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  eventDesc: {
    margin: 0,
    fontSize: "12px",
    color: "#4b5563",
  },
  deleteButton: {
    background: "none",
    border: "none",
    color: "#ef4444",
    fontSize: "18px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  emptySlot: {
    fontSize: "12px",
    color: "#d1d5db",
    fontStyle: "italic",
    paddingTop: "4px",
  },
};
